import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { EnquiryPurposeColumns } from "../../../tableColumns/table-columns";
import { EnquiryPurposeJson } from "../../../DynamicFormsJson/MastersJSON/enquiryPurpose";
import { getEnquiryPurpose } from "../../../Slice/enquiryOperations.slice";
import endpoint from "../../../config/endpoints";

class EnquiryPurpose extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { enquiryPurpose, getEnquiryPurpose } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={EnquiryPurposeJson.formPath}
                    screenTitle={EnquiryPurposeJson.screenTitle}
                    fieldMeta={EnquiryPurposeJson.fieldMeta}
                    showPdfDownload={EnquiryPurposeJson.showPdfDownload}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={EnquiryPurposeJson.pdfFileName}
                    excelFileName={EnquiryPurposeJson.excelFileName}
                    showAddButton={EnquiryPurposeJson.showAddButton}
                    tableColumnsToFilter={EnquiryPurposeJson.tableColumnsToFilter}
                    tableColumns={EnquiryPurposeColumns}
                    tableData={enquiryPurpose?.enquiryPurpose}
                    getTableData={getEnquiryPurpose}
                    apiBaseURL={EnquiryPurposeJson.apiBaseURL}
                    baseIdColumn={EnquiryPurposeJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={EnquiryPurposeJson.noteValue}
                    showDeleteIcon={true}
                    showViewButtonInTable={false}
                    formPathView={EnquiryPurposeJson.formPathView}
                    isActiveURL={EnquiryPurposeJson.isActiveURL}
                    isActiveURLGET={true}
                    showView={false}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    enquiryPurpose: state.enquiryOperations,
});

const mapDispatchToProps = {
    getEnquiryPurpose,
};

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryPurpose);